
export const galleryPresets = [
    {
        bezierCurve: [0.26, 0.0, 0.4, 1.0],
        offset: 65,
        duration: 1300,
        opacity: true,
        opacityDelay: 0,
        direction: 'bottom',
        reveal: 'multiline',
        perspective: false,
        multilineOffsetDelay: 200,
        multilineMasking: false,
        wordOffsetDelay: 200,
        characterOffsetDelay: 25,
        characterWordSpacing: 10, 
      },

      {
        bezierCurve: [0.0, 0.4, 0.4, 1.0],
        offset: 45,
        duration: 1275,
        opacity: true,
        opacityDelay: 0,
        direction: 'top',
        reveal: 'character',
        perspective: false,
        multilineOffsetDelay: 200,
        multilineMasking: true,
        wordOffsetDelay: 200,
        characterOffsetDelay: 25,
        characterWordSpacing: 10,
      },

      {
        bezierCurve: [0, 0.4, 0.4, 1],
        offset: 225,
        duration: 2500,
        opacity: true,
        opacityDelay: 0,
        direction: 'bottom',
        reveal: 'character',
        multilineOffsetDelay: 200,
        multilineMasking: false,
        perspective: true,
        perspectiveX: 158,
        perspectiveY: 13,
        perspectiveZ: 0,
        wordOffsetDelay: 200,
        characterOffsetDelay: 95,
        characterWordSpacing: 10,
        lastUpdate: 1559875613758
      },

      {
        bezierCurve: [0.2, 0.51, 0.22, 1.0],
        offset: 25,
        duration: 1000,
        opacity: true,
        opacityDelay: 0,
        direction: 'bottom',
        reveal: 'all',
        perspective: false,
        multilineOffsetDelay: 200,
        multilineMasking: false,
        wordOffsetDelay: 200,
        characterOffsetDelay: 25,
        characterWordSpacing: 10, 
      },

      {
        bezierCurve: [0.0, 0.4, 0.4, 1.0],
        offset: 100,
        duration: 500,
        opacity: true,
        opacityDelay: 0,
        direction: 'bottom',
        reveal: 'word',
        perspective: false,
        multilineOffsetDelay: 200,
        multilineMasking: false,
        wordOffsetDelay: 200,
        characterOffsetDelay: 25,
        characterWordSpacing: 10, 
      },

      {
        bezierCurve: [0.5848375451263538, -0.003374999999999906, 0.16606498194945848, 1.012625],
        offset: 120,
        duration: 1875,
        opacity: true,
        opacityDelay: 0,
        direction: 'bottom',
        reveal: 'character',
        multilineOffsetDelay: 575,
        multilineMasking: false,
        perspective: true,
        perspectiveX: 158,
        perspectiveY: 13,
        perspectiveZ: 0,
        wordOffsetDelay: 200,
        characterOffsetDelay: 95,
        characterWordSpacing: 10,
        lastUpdate: 1559876260486
      },

      {
        bezierCurve: [0.0, 0.4, 0.4, 1.0],
        offset: 100,
        duration: 500,
        opacity: true,
        opacityDelay: 0,
        direction: 'bottom',
        reveal: 'word',
        perspective: false,
        multilineOffsetDelay: 200,
        multilineMasking: false,
        wordOffsetDelay: 200,
        characterOffsetDelay: 25,
        characterWordSpacing: 10, 
      },

      {
        bezierCurve: [0.0, 0.4, 0.4, 1.0],
        offset: 100,
        duration: 500,
        opacity: true,
        opacityDelay: 0,
        direction: 'bottom',
        reveal: 'word',
        perspective: false,
        multilineOffsetDelay: 200,
        multilineMasking: false,
        wordOffsetDelay: 200,
        characterOffsetDelay: 25,
        characterWordSpacing: 10, 
      },

      {
        bezierCurve: [0, 0.4, 0.4, 1],
        offset: 225,
        duration: 2500,
        opacity: true,
        opacityDelay: 0,
        direction: 'bottom',
        reveal: 'character',
        multilineOffsetDelay: 200,
        multilineMasking: false,
        perspective: true,
        perspectiveX: 158,
        perspectiveY: 13,
        perspectiveZ: 0,
        wordOffsetDelay: 200,
        characterOffsetDelay: 95,
        characterWordSpacing: 10,
      },

      


];